module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cn":{"work":"名称","client":"客户","artist":"艺术家"},"en":{"work":"Work","client":"Client","artist":"Artist"}}')
  delete Component.options._Ctor
}
